
import Vue from "vue";

import AppLogoSettings from "@/components/layout-editor/LogoSettings.vue";
import AppPageSettings from "@/components/layout-editor/PageSettings.vue";
import AppTab from "@/components/layout-editor/Tab.vue";
import { ReminderLayout } from "@/utils/reminder-layouts/reminder-layout";
import AppColumnNameSettings from "./ColumnNameSettings.vue";
import AppFreeLineSettings from "./FreeLineSettings.vue";
import AppHeadingSettings from "./HeadingSettings.vue";
import AppTextSettings from "./TextSettings.vue";
import AppPdfPreview from "./PdfPreview.vue";
import AppFreeBlockSettings from "./FreeBlocksSettings.vue";import { FreeBlock } from "@/utils/documents/free-block";


export default Vue.extend({
	data(){
		return {
			toEditFreeBlock: null as null | FreeBlock
		};
	},
	props: {
		tab: Number,
		layout: {
			type: Object as () => ReminderLayout,
			required: true
		}
	},
	watch: {
		tab: {
			handler(){
				if (this.tab != 6){
					this.toEditFreeBlock = null;
				}
			}
		}
	},
	methods: {
		async onOpenFreeBlock(block:FreeBlock){
			this.toEditFreeBlock = block;
			this.$emit("update:tab", 6);
		}
	},
	components: {
		AppTab,
		AppPageSettings,
		AppHeadingSettings,
		AppLogoSettings,
		AppTextSettings,
		AppFreeLineSettings,
		AppColumnNameSettings,
		AppPdfPreview,
		AppFreeBlockSettings
	},
});
